import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import * as TFactoryActions from './factory.actions';
import * as TFactorySelections from './factory.selectors';

@Injectable({ providedIn: 'root' })
export class FactoryFacade {
  constructor(private store: Store<TMachineMaintenanceState>) {}

  getFactoryId() {
    return this.store.pipe(select(TFactorySelections.getFactoryId));
  }

  updateFactoryId(factoryId: string) {
    this.store.dispatch(new TFactoryActions.SetFactoryId(factoryId));
  }

  getUserName() {
    return this.store.pipe(select(TFactorySelections.getUserName));
  }

  setUserName(userName: string) {
    this.store.dispatch(new TFactoryActions.SetUserName(userName));
  }
}
